<template>
	<div id="plain-grid" class="plain-grid relative">
		<h1 :class="[ 'heading p-5 text-xl sm:text-lg md:text-2xl lg:text-3xl text-center text-gray-700 border-b border-b-1 border-mlt-grey' ]">
			An unmatched quality that you can always trust
		</h1>


		<ul :class="[ 'grid grid-cols-1 sm:grid-cols-3 sm:row-gap-10 py-10' ]">
      <li v-if="!getPlainImg.length">
        <Loading />
      </li>

			<li v-else v-for="(item, index) in getPlainImg" :key="index" :class="[ 'flex flex-col flex-wrap items-center justify-center' ]">
				<a
          href="#"
          :class="[ 'w-64 sm:w-32 flex flex-wrap justify-center transition duration-300 relative overflow-hidden' ]"
        >

					<picture class="img">
						<img :src="item.img.indexOf('http') !== -1 ? item.img : require(`@/img/${item.img}`)" :alt="item.title" width="350" height="350" />
					</picture>
				</a>
			</li>
		</ul>
	</div>
</template>

<script>
import Loading from "@/components/Loading.vue";
import axios from 'axios';
import { mapActions, mapGetters } from 'vuex';
//import gsap from 'gsap';

export default {
	name: 'PlainGrid',

  components: {
    Loading,
  },

	data() {
		return {
      id: null,
		}
	},

	computed: {
		...mapGetters([ 'getPlainImg', 'getUrlApi' ]),
	},

	mounted: function () {
    axios.get(`${this.getUrlApi}/wp/v2/categories/?slug=catalogue`).then(res => {
      this.id = res.data[0].id;

      axios.get(`${this.getUrlApi}/wp/v2/portfolios/?categories=${this.id}`).then(res => {
        this.setCatalogue(res.data);
      }).catch(err => console.log(err));
    }).catch(err => console.log(err));

		// Created a new timeline
		//var brandTl = gsap.timeline({ defaults: { duration: 1 } });
		//brandTl
		//	.staggerFromTo('.img', 1, { translateY: 50, scale: 0.75, opacity: 0 }, { duration: 1.5, translateY: 0, scale: 1, opacity: 1 }, 0.25 )
		
	},

  methods: {
    ...mapActions({
      setCatalogue: 'setCatalogue',
    }),
  },
}
</script>

<style lang="scss" scoped>
</style>
